(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryRating', CountryRating);

    CountryRating.$inject = ['$resource'];

    function CountryRating ($resource) {
        var resourceUrl =  'api/rating';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
